<template>
  <WpPage :pageId="2" :pageSlug="'home'" />
</template>

<script setup>
import WpPage from '~/components/WpPage.vue';
</script>